import React, { useState } from 'react';

const PRODUCTS = [
  {
    id: 'penflow', status: 'live', emoji: '✍️', name: 'PenFlow',
    tagline: 'Content Writing Platform on Pi Network', color: '#0F6E56',
    desc: 'Write, earn Pi, connect with pioneers. The first blogging platform built on Pi Network with real Pi payments, social networking, and content monetization.',
    features: ['✍️ Write & Earn Pi', '💰 Tip Authors', '🤝 Connect & Network', '💬 Real-time Chat', '🚀 Boost Posts', '🎮 Games', '🛠️ Tools', '📒 Pi Ledger', '🔔 Notifications'],
    url: 'https://penflow.xpertcreation.com', btnText: 'Open PenFlow',
  },
  {
    id: 'marketplace', status: 'live', emoji: '🛍️', name: 'Marketplace',
    tagline: 'Pi-Powered E-Commerce Marketplace', color: '#0F6E56',
    desc: 'Buy and sell physical or digital products using Pi, directly between merchants and buyers on the network.',
    features: ['🛒 Buy & Sell Products', '💰 Pay with Pi', '📦 Seller Inventory', '⭐ Product Reviews', '🎟️ Vouchers & Deals', '📄 Order Tracking'],
    url: 'https://penflow.xpertcreation.com/marketplace', btnText: 'Open Marketplace',
  },
  {
    id: 'freelance', status: 'live', emoji: '💼', name: 'Freelance',
    tagline: 'Pi-Powered Freelancing Marketplace', color: '#0F6E56',
    desc: 'Hire or work as a freelancer and get paid in Pi. Post gigs or jobs, submit proposals, and use escrow-style payments.',
    features: ['💼 Post Jobs & Gigs', '🔒 Pi Escrow Payments', '⭐ Reviews & Ratings', '🏆 Top Freelancer Badges', '💬 Client Chat'],
    url: 'https://penflow.xpertcreation.com/freelance', btnText: 'Open Freelance',
  },
  {
    id: 'travel', status: 'live', emoji: '🏨', name: 'Travel',
    tagline: 'Pi-Powered Stay Booking Marketplace', color: '#0F6E56',
    desc: 'Book stays anywhere, or host your own place - paid entirely in Pi. Photo galleries, map view, and in-app messaging.',
    features: ['🏨 Book a Stay', '🗺️ Map View', '💬 Message Host', '📸 Photo Gallery', '📋 House Rules'],
    url: 'https://penflow.xpertcreation.com/travel', btnText: 'Open Travel',
  },
  {
    id: 'meetup', status: 'live', emoji: '📅', name: 'Meetup',
    tagline: 'Events & Groups, Paid in Pi', color: '#0F6E56',
    desc: 'Find and join events, or create your own groups and gatherings - RSVP and ticketing paid in Pi.',
    features: ['📅 Find Events', '👥 Create Groups', '🎟️ Pi Ticketing', '📍 Location-based'],
    url: 'https://penflow.xpertcreation.com/meetup', btnText: 'Open Meetup',
  },
  {
    id: 'academy', status: 'live', emoji: '🎓', name: 'Academy',
    tagline: 'Pi-Powered Learning Platform', color: '#0F6E56',
    desc: 'Learn new skills and pay for courses with Pi. Teach others and earn Pi as an instructor.',
    features: ['📚 Online Courses', '💰 Pay/Earn with Pi', '👨‍🏫 Become an Instructor', '📹 Video Lessons'],
    url: 'https://penflow.xpertcreation.com/academy', btnText: 'Open Academy',
  },
  {
    id: 'realty', status: 'live', emoji: '🏠', name: 'Realty',
    tagline: 'Pi-Based Real Estate Platform', color: '#0F6E56',
    desc: 'Post, browse, and inquire about properties for sale or rent, with a built-in mortgage calculator.',
    features: ['🏠 Buy & Sell Property', '🔑 Rent Listings', '📍 Location Maps', '💰 Mortgage Calculator', '🤝 Agent Ratings'],
    url: 'https://penflow.xpertcreation.com/realty', btnText: 'Open Realty',
  },
  {
    id: 'matrimony', status: 'live', emoji: '💗', name: 'Matrimony',
    tagline: 'Find a Life Partner on Pi', color: '#0F6E56',
    desc: 'Real, verified Pi-identity profiles to help you find a life partner.',
    features: ['💗 Verified Profiles', '🔍 Advanced Filters', '⭐ Shortlist', '💬 Match Requests'],
    url: 'https://penflow.xpertcreation.com/matrimony', btnText: 'Open Matrimony',
  },
  {
    id: 'nft', status: 'live', emoji: '🖼️', name: 'NFT',
    tagline: 'Mint, Collect & Trade, Paid in Pi', color: '#0F6E56',
    desc: 'Mint digital collectible items, build collections, and trade with other pioneers - all paid in Pi.',
    features: ['🖼️ Mint Items', '💎 Rarity Tiers', '🔄 Trade & Resell', '📂 Collections'],
    url: 'https://penflow.xpertcreation.com/nft', btnText: 'Open NFT',
  },
  {
    id: 'petcare', status: 'live', emoji: '🐾', name: 'PetCare',
    tagline: 'Pet Health & Community', color: '#0F6E56',
    desc: 'Manage pet health records, book vet appointments, and browse adoption or sale listings.',
    features: ['🐾 Health Records', '📅 Vet Appointments', '🏷️ Adoption Listings', '🔍 Lost & Found'],
    url: 'https://penflow.xpertcreation.com/petcare', btnText: 'Open PetCare',
  },
  {
    id: 'familytree', status: 'live', emoji: '🌳', name: 'Family Tree',
    tagline: 'Build & Share Your Family History', color: '#0F6E56',
    desc: 'Build a family tree, keep a shared photo album, and maintain a family phone book together.',
    features: ['🌳 Family Tree', '📸 Photo Album', '📞 Phone Book', '🔗 Invite Family'],
    url: 'https://penflow.xpertcreation.com/family-tree', btnText: 'Open Family Tree',
  },
  {
    id: 'games', status: 'live', emoji: '🎮', name: 'Xpert Games',
    tagline: 'Play & Compete', color: '#0F6E56',
    desc: 'Snake, Tetris (with real-time online multiplayer), Platformer, Fighter, and UNO, with global leaderboards.',
    features: ['🐍 Snake', '🧱 Tetris (Multiplayer)', '🥊 Fighter', '🃏 UNO', '🏆 Leaderboards'],
    url: 'https://penflow.xpertcreation.com/games', btnText: 'Open Games',
  },
];

function ProductCard({ product, expanded, onToggle }) {
  return (
    <div style={{ ...styles.card, borderTop: `4px solid ${product.color}` }}>
      <div style={styles.cardHeader} onClick={onToggle}>
        <div style={styles.cardLeft}>
          <div style={{ ...styles.emoji, backgroundColor: product.color + '22' }}>{product.emoji}</div>
          <div>
            <div style={styles.productName}>{product.name}</div>
            <div style={styles.tagline}>{product.tagline}</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ ...styles.statusBadge, backgroundColor: product.status === 'live' ? '#10b981' : '#0d9488' }}>
            {product.status === 'live' ? '🟢 Live' : '🔜 Soon'}
          </span>
          <span style={{ color: '#999', fontSize: '18px' }}>{expanded ? '▲' : '▼'}</span>
        </div>
      </div>

      {expanded && (
        <div style={styles.cardBody}>
          <p style={styles.desc}>{product.desc}</p>
          <div style={styles.featuresGrid}>
            {product.features.map((f, i) => (
              <div key={i} style={styles.feature}>{f}</div>
            ))}
          </div>
          {product.url ? (
            <a href={product.url} style={{ ...styles.btn, backgroundColor: product.color }}>
              {product.btnText} →
            </a>
          ) : (
            <div style={{ ...styles.btn, backgroundColor: '#999', cursor: 'default' }}>{product.btnText}</div>
          )}
        </div>
      )}
    </div>
  );
}

export default function XpertCreation() {
  const [expanded, setExpanded] = useState('penflow');

  return (
    <div style={styles.page}>
      {/* Hero */}
      <div style={styles.hero}>
        <div style={styles.heroInner}>
          <img src="/xplogo.jpg" alt="XpertCreation" style={{ width: '80px', height: '80px', borderRadius: '16px', marginBottom: '10px', objectFit: 'cover' }} />
          <div style={styles.logo}>XpertCreation</div>
          <h1 style={styles.heroTitle}>Building the Pi Economy</h1>
          <p style={styles.heroSub}>A suite of Pi Network-powered apps for work, life, learning & earning</p>
          <div style={styles.piTag}>Powered by 🥧 Pi Network</div>
        </div>
      </div>

      {/* Products */}
      <div style={styles.products}>
        <h2 style={styles.sectionTitle}>Our Ecosystem</h2>
        {PRODUCTS.map(p => (
          <ProductCard
            key={p.id}
            product={p}
            expanded={expanded === p.id}
            onToggle={() => setExpanded(expanded === p.id ? null : p.id)}
          />
        ))}
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <p style={{ margin: '0 0 8px', fontWeight: 'bold', color: '#6200ea' }}>⚡ XpertCreation</p>
        <p style={{ margin: '0 0 4px', color: '#666', fontSize: '13px' }}>CEO: Syed Khalid Hussain Shah</p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '8px' }}>
          <a href="https://xpertcreation.com" style={{ color: '#6200ea', fontSize: '13px' }}>🌐 Website</a>
          <a href="https://twitter.com/khalidxpert" target="_blank" rel="noopener noreferrer" style={{ color: '#000', fontSize: '13px' }}>𝕏 @khalidxpert</a>
          <a href="https://discord.gg/Dtu976rr3u" target="_blank" rel="noopener noreferrer" style={{ color: '#5865F2', fontSize: '13px' }}>💬 Discord</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { maxWidth: '700px', margin: '0 auto', padding: '0 0 40px' },
  hero: { background: 'linear-gradient(135deg, #0f0c29, #302b63, #24243e)', padding: '40px 20px', textAlign: 'center' },
  heroInner: { maxWidth: '500px', margin: '0 auto' },
  logo: { color: '#34d399', fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' },
  heroTitle: { color: 'white', fontSize: '28px', fontWeight: '900', margin: '0 0 10px' },
  heroSub: { color: 'rgba(255,255,255,0.7)', fontSize: '14px', margin: '0 0 16px', lineHeight: 1.6 },
  piTag: { display: 'inline-block', backgroundColor: 'rgba(255,255,255,0.1)', color: 'white', padding: '6px 16px', borderRadius: '20px', fontSize: '13px', border: '1px solid rgba(255,255,255,0.2)' },
  products: { padding: '20px' },
  sectionTitle: { color: '#6200ea', marginBottom: '16px', fontSize: '20px' },
  card: { backgroundColor: 'white', borderRadius: '16px', marginBottom: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', overflow: 'hidden' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', cursor: 'pointer' },
  cardLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  emoji: { width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0 },
  productName: { fontWeight: 'bold', color: '#333', fontSize: '16px' },
  tagline: { color: '#999', fontSize: '12px', marginTop: '2px' },
  statusBadge: { color: 'white', padding: '3px 10px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold' },
  cardBody: { padding: '0 16px 16px' },
  desc: { color: '#555', fontSize: '14px', lineHeight: 1.6, margin: '0 0 14px' },
  featuresGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', marginBottom: '16px' },
  feature: { backgroundColor: '#f3e5f5', color: '#6200ea', padding: '6px 10px', borderRadius: '8px', fontSize: '12px', fontWeight: '500' },
  btn: { display: 'block', textAlign: 'center', color: 'white', padding: '12px', borderRadius: '10px', textDecoration: 'none', fontWeight: 'bold', fontSize: '15px' },
  footer: { textAlign: 'center', padding: '20px', borderTop: '1px solid #eee', margin: '0 20px' },
};
